// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"31e213caa78ddce14530","682":"fec87afe5e99d23cd4e3","883":"b22ac1976db1e3d82f24"}[chunkId] + ".js";
};